import { Table, Spin } from 'antd';
import React from 'react';
import TableWithSorter from '../../../../components/Common/TableWithSorter';

const PromoTable = ({
  data,
  current,
  totalCount,
  onPaginationChange,
  offset,
  fetching,
  columns,
}) => {
  return (
    <div>
      {fetching ? <Spin /> : null}
      {data.length > 0 ? (
        <div>
          <div>Total count: {totalCount}</div>
          <TableWithSorter
            columns={columns}
            dataSource={data}
            pagination={{
              current: current,
              total: totalCount,
              defaultPageSize: 20,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '30'],
            }}
            onChange={onPaginationChange}
          />
        </div>
      ) : null}
      {data.length === 0 && !fetching ? <div>No record found</div> : null}
    </div>
  );
};

export default PromoTable;
